import { render, staticRenderFns } from "./clipper-fixed.vue?vue&type=template&id=fb0a7a42&scoped=true&"
import script from "./clipper-fixed.vue?vue&type=script&lang=js&"
export * from "./clipper-fixed.vue?vue&type=script&lang=js&"
import style0 from "./clipper-fixed.vue?vue&type=style&index=0&id=fb0a7a42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0a7a42",
  null
  
)

export default component.exports